// Filename: uinav.js
// Timestamp: 2018.12.09-00:27:07 (last modified)
// Author(s): bumblehead <chris@bumblehead.com>

import gnnodexuipart from '../gnnodexuipart.js'

import {
  gndom_nodeelem,
  gndom_evidkeyarrget,
  gndom_elemclasstoggle
} from '../gndom.js'

import {
  gnenumXONCLICK as XONCLICK,
  gnenumPARTKEYPART as PARTKEYPART,
  gnenumPARTKEYDOC as PARTKEYDOC,
  gnenumPARTISACTIVE as PARTISACTIVE
} from '../gnenum.js'

const xvnode = (ss, cfg, gr, nd, ndx, subj) => {
  const subjtag = subj.tag
  const tags = cfg.h(ndx, nd)
  const ul = tags.ul
  const li = tags.li

  return (
    ul('.:ui#:key', ndx.partAtomsMap(nd, part => (
      li('.:ui-item', [(part => {
        const label = part.label
        const href = part.href
        const tag = (typeof href === 'string' && 'a') || part.tag || subjtag

        return typeof tag !== 'string' ? label : (
          tags[tag](`.:ui-item-target.st-isactive-${part[PARTISACTIVE]}`, {
            target: part.target,
            id: part[PARTKEYDOC],
            href: href
          }, [label]))
      })(part)])
    )))
  )
}

const xonclick = async (ss, cfg, gr, nd, ndx, prev, subj, ev) => {
  const partkey = (gndom_evidkeyarrget(cfg, ev) || [])[1]

  if (partkey) {
    const value = await ndx.returnValFromPartKey(ss, cfg, gr, nd, ndx, partkey)

    ndx.publishev(ss, cfg, nd, XONCLICK, { value })
  }
}

const setactive = (ss, cfg, gr, nd, ndx, { value }) => (
  ndx.partAtomsMap(nd, part => {
    const partkey = part[PARTKEYPART]
    const partelem = gndom_nodeelem(cfg, nd, partkey)

    gndom_elemclasstoggle(partelem, 'st-isactive', partkey === value)
  })
)

const xonsubj = (ss, cfg, gr, nd, ndx, prev, { value }) => (
  ndx.setactive(ss, cfg, gr, nd, ndx, { value }),
  true)

export default Object.assign({}, gnnodexuipart, {
  type: 'uilsparts',
  xvnode,
  xonclick,
  xonsubj,
  setactive
})
